import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/** Restores deep links after static host serves index.html at `/`. */
const CccSPARedirectHandler: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      const storedPath = sessionStorage.getItem('ccc_spa_redirect_path');
      if (!storedPath || typeof storedPath !== 'string') return;
      sessionStorage.removeItem('ccc_spa_redirect_path');
      if (storedPath.startsWith('/') && !storedPath.startsWith('//')) {
        navigate(storedPath, { replace: true });
      }
    } catch {
      /* sessionStorage unavailable */
    }
  }, [navigate]);

  return null;
};

export default CccSPARedirectHandler;
